"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformConditionalTokensToHtml = void 0;
const token_1 = require("../../token");
const replace_conditional_tokens_1 = require("../../token/replace-conditional-tokens");
const transformConditionalTokensToHtml = (html) => {
    return (0, replace_conditional_tokens_1.replaceConditionalTokens)(html, (tokenData) => {
        return (0, token_1.transformTokenObjectToHtml)({
            name: tokenData.name,
            class: 'cb-token cb-token-conditional',
            type: 'conditional',
        });
    });
};
exports.transformConditionalTokensToHtml = transformConditionalTokensToHtml;
//# sourceMappingURL=transform-conditional-tokens-to-html.js.map